import baseFetch from '@/network/baseFetch'
import { REQUEST_METHODS } from '@/constants/network'

export function parseWorkplusUserIdFromUseridCookie(useridRaw: string): string {
  if (!useridRaw || useridRaw === 'null') return ''
  const decoded = decodeURIComponent(useridRaw)
  const parts = decoded.split('|')
  return parts[4] ?? ''
}

export function isCfwStateResponse(data: string): boolean {
  return ['TRIAL', 'TRIAL_NCB'].indexOf(data) > -1
}


export async function fetchWorkplusIsCfwUser(userId: string): Promise<boolean> {
  if (!userId) return false

  const data = await baseFetch<string>({
    url: '/workplus/user/state',
    method: REQUEST_METHODS.GET,
    params: { userId },
  
  })

  if (!data) return false
  return isCfwStateResponse(data)
}